import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-animated-modal";
import { PulseLoader } from 'halogenium';
import Select from 'react-select';
import { CancelOrderType, cancelOrderTypes } from '../../app/Common/Enum/CancelOrderType'

var portalRoot = null;

class ConfirmModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#confirm-modal').length == 0) {
            $('body').prepend('<div id="confirm-modal"></div>')
        }
        portalRoot = document.getElementById("confirm-modal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}
class ConfirmModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedReason: null,
            otherReason: null
        }
    }
    isLoading(isLoading, callback) {
        if (!this.unmounted) {
            this.setState({isLoading}, () => {callback && callback()})
        }
    }
    componentWillUnmount = () => {
        this.unmounted = true;
        $(document).unbind('keypress', this.enterKeyListener)
        $(document).unbind('keyup',this.escListener);
    };
    componentDidMount = () => {
        // Set reference to that can be removed at componentWillUnmount
        this.enterKeyListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                this.props.onYes && this.props.onYes()
            }
        }
        this.escListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '27'){
                this.props.onNo && this.props.onNo()
            }
        }
        this.unmounted = false
        $(document).keypress(this.enterKeyListener);
        $(document).keyup(this.escListener);

    };
    onClose = () => {}

    // Parent to call this to dismiss the modal
    close() {
        this.props.onClose()
    }
    onSelectedReason = (event) => {
        event.persist();
        this.setState({ selectedReason: event.target.value });
    }
    otherReasonUpdateClicked = (val) => {
        this.setState({ otherReason : val })
    }
    checkingOthers = () => {
        if (this.state.selectedReason && this.state.selectedReason == "0") {
            return (
                <>
                <textarea className="form-control rounded-0 mt-3" onChange={ (e) => this.otherReasonUpdateClicked(e.target.value) } placeholder="Other Reason" required></textarea>
                </>
            )
        }
    }
    cancelModal = () => {
        return (
            <div className="mb-2">
                <label htmlFor="txtReason">Select your reason</label>
                    <div>
                    {
                        cancelOrderTypes.map( (cancelOrderType) => {
                            return <>
                                <input type="radio" value={cancelOrderType.key} checked={this.state.selectedReason == cancelOrderType.key} onChange={this.onSelectedReason} name={"cancel_order_reason_"+cancelOrderType.key}/> &nbsp;{cancelOrderType.label} <br/>
                                </>
                            } )
                    }
                    </div>
                    <input type="radio" value="0" checked={this.state.selectedReason == 0} onChange={this.onSelectedReason} name={"cancel_order_reason_0"}/> &nbsp; Others <br/>
                    {this.checkingOthers()}
            </div>
        )
    }
    postCancelReason = () => {
        if(this.state.selectedReason) {
            if(this.props.cancelOrderProp) {
                $.ajax({
                    url: `/table_sessions/${this.props.table_session_id}/cancel_order/reason`,
                    type: "POST",
                    data: { 
                        cancel_reason_type_id: this.state.selectedReason,
                        other_cancel_reason: this.state.otherReason ? this.state.otherReason : null
                    },
                    error: ajaxFails,
                })
                this.props.onYes()
            } 
        } else {
            alert("Please Select a reason.")
        }
    }
    getButtons = () => {
        if (this.props.buttonLayout == "vertical") {
            return (
                <div className="mt-3">
                    <button id="confirm-modal-btn-yes" onClick={this.props.onYes} className={"btn btn-block mb-2 "+(this.props.isYesDestructive ? "btn-danger" : "btn-success")}>{this.props.yesText || lang.confirm}</button>
                    <button id="confirm-modal-btn-no" onClick={this.props.onNo} className="btn btn-default btn-block">{this.props.noText || lang.cancel}</button>
                </div>
            )
        }
        else {
            // Default is horizontal layout
            return (
                <div style={{textAlign:"right"}}>
                    <button onClick={this.props.onNo} className="btn btn-primary btn-sm mr-2">{this.props.noText || lang.cancel}</button>
                    <button onClick={this.props.cancelOrderProp ? () => {this.postCancelReason()} : this.props.onYes} className="btn btn-primary btn-sm">{this.props.yesText || lang.confirm}</button>
                </div>
            )
        }
    }
    render() {
        return (
            <ConfirmModalPortal>
                <Modal
                    visible={true}
                    closemodal={this.props.onClose}
                    type="pulse">
                    <div className="menu-modal" style={{padding:"20px"}}>
                        <div>
                            {this.props.customBody || this.props.message}
                        </div>
                        <p>{this.props.pickup}</p>
                        {
                            this.props.cancelOrderProp ?
                            this.cancelModal() : null
                        }
                        { 
                            this.state.isLoading ? 
                            <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} /> :
                            this.getButtons()
                        }
                    </div>
                </Modal>
            </ConfirmModalPortal>
        )
    }
}
ConfirmModal.defaultProps = {
    customBody:null,
    message: "",
    buttonLayout: "default",
    isYesDestructive: false
}
export default ConfirmModal;